// extracted by mini-css-extract-plugin
module.exports = {"image":"EnergyPreviewImage_image__SKdam"};